export default __webpack_public_path__ + "static/media/techno001.33faffc0.png";